import { ActionEvent, Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  private popstateHandler = this.handlePopstate.bind(this);

  connect() {
    window.addEventListener("popstate", this.popstateHandler);
  }

  disconnect() {
    window.removeEventListener("popstate", this.popstateHandler);
  }

  navigate(event: ActionEvent) {
    const location = event.params.location;
    if (!location) {
      return;
    }

    const frame = document.querySelector<HTMLElement>("turbo-frame#plan-content");
    if (frame) {
      frame.setAttribute("src", location);
      history.pushState({}, "", location);
    } else {
      Turbo.visit(location);
    }
  }

  private handlePopstate() {
    const frame = document.querySelector<HTMLElement>("turbo-frame#plan-content");
    if (frame) {
      frame.setAttribute("src", window.location.href);
      this.syncRadioSelection();
    }
  }

  private syncRadioSelection() {
    const url = new URL(window.location.href);
    const planId = url.searchParams.get("plan_id");
    if (!planId) {
      return;
    }

    const radio = this.element.querySelector<HTMLInputElement>(
      `input[type="radio"][value="${planId}"]`,
    );
    if (radio) {
      radio.checked = true;
    }
  }
}
